export const MIXPANEL_EVENT = Object.freeze({
    PREACTIVATION_SUCCESS: {
        event: 'preactivationSuccess',
        property: {
            SERIAL_PREFIX: 'serialPrefix',
            RMA_SERIAL_PREFIX: 'rmaSerialPrefix',
            LICENSE_PLATE_PRESENT: 'licensePlatePresent',
            GENERATION_SELECTED: 'generationSelected'
        }
    },
    PREACTIVATION_FAILURE: {
        event: 'preactivationFailure',
        property: {
            SERIAL_PREFIX: 'serialPrefix',
            RMA_SERIAL_PREFIX: 'rmaSerialPrefix',
            LICENSE_PLATE_PRESENT: 'licensePlatePresent',
            GENERATION_SELECTED: 'generationSelected'
        }
    },
    COOKIES_CONSENT_ACCEPTED: 'cookiesConsentAccepted'
})
